import { useEffect, useRef, useState } from 'react';
import { SignUpCard } from '../SignUpCard';
import { UnauthedPageWithNavbar } from '../UnauthedPageWithNavbar';
import SocialEntrepreneur from './social-entrepreneur.svg';
import Volunteer from './volunteer.svg';

type AccountSelectionPageProps = {
  setRepresentativeSelected: (selected: boolean) => void;
  setVolunteerSelected: (selected: boolean) => void;
};
export const AccountSelectionPage = (props: AccountSelectionPageProps) => {
  const { setRepresentativeSelected, setVolunteerSelected } = props;

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const hideSidebar = (e: MouseEvent) => {
      if (isSidebarOpen && !e.composedPath().includes(sidebarRef.current as HTMLDivElement)) {
        setIsSidebarOpen(false);
      }
    };

    document.addEventListener('click', hideSidebar, true);
    return () => document.removeEventListener('click', hideSidebar, true);
  }, [isSidebarOpen]);

  return (
    <UnauthedPageWithNavbar>
      <div className='md:w-full flex flex-col items-center mt-[20px] md:mt-[100px] gap-10 l px-4'>
        <h3 className='text-center text-display-md font-medium text-gray-700'>
          Select your account type
        </h3>
        <div className='flex flex-col md:flex-row gap-[48px]'>
          <SignUpCard
            img={Volunteer}
            header='Volunteer'
            description='I want to volunteer my skills for social good'
            onClick={() => {
              setVolunteerSelected(true);
              setRepresentativeSelected(false);
            }}
          />
          <SignUpCard
            img={SocialEntrepreneur}
            header='Social Entrepreneur'
            description='I want support to grow my organization'
            onClick={() => {
              setVolunteerSelected(false);
              setRepresentativeSelected(true);
            }}
          />
        </div>
        <div className='pb-8 md:pb-0'>
          Already have an account?{' '}
          <a className='text-brand-500 underline' href='/platform/auth/login' target='_blank'>
            Log in
          </a>
        </div>
      </div>
    </UnauthedPageWithNavbar>
  );
};
